import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable, of } from 'rxjs';
import { Dispatch } from '../models/dispatch/dispatch.model';
import { Constants } from '../configs';

@Injectable({
  providedIn: 'root'
})
export class DispatchFilterService {

  constructor(public apiService: ApiService) { }

  getOrders(dispatchConfirmRequest: string): Observable<Dispatch[]> {
    const api: string = this.apiService.businessDispatchRead + '/dispatches?' + dispatchConfirmRequest;
    return this.apiService.get(api).pipe();
  }

  updateDispatches(request) {
    return this.apiService.put(this.apiService.dispatch + '/assign', request).pipe();
  }

  getListDispatchType(): Observable<any> {
    return of(Constants.SaleConfig.typeSend);
  }

  getListPaymentMethod(): Observable<any> {
    return of(Constants.ConfigQuotation.PAYMENT_TYPES_ENTERPRISE.getProps());
  }

  printerDispatch(listOfDispatches): Observable<any> {
    return this.apiService.postHTML(`${this.apiService.dispatch}/invoice`, listOfDispatches).pipe();
  }

  eventMultipleSend(body): Observable<any> {
    return this.apiService.put(`${this.apiService.dispatch}/event`, body).pipe();
  }

  /**
   * Crear body para confirmaciones por lote
   * @param dispatches lista de despachos
   * @param type tipo de event entrega multiple
   */
  createBodyEvent(dispatches: any[], type) {
    return {
      event: type,
      origin: 'DISPATCH_MODULE',
      items: dispatches.map(dispatch => {
        return {
          companyCode: dispatch.companyCode,
          dispatchDate: dispatch.dispatchItems.dispatchDate,
          dispatchId: dispatch.dispatchId,
          pendingAmount: dispatch.dispatchItems.pendingAmount - dispatch.dispatchItems.processedAmount,
          processedAmount: dispatch.dispatchItems.processedAmount,
          saleNoteId: dispatch.saleNoteId,
          skuCode: dispatch.dispatchItems.skuCode,
          skuPartialSequence: dispatch.dispatchItems.skuPartialSequence,
          state: dispatch.dispatchItems.state,
          stateId: dispatch.dispatchItems.stateId,
          rejectId: dispatch.dispatchItems.rejectId,
          rejectName: dispatch.dispatchItems.rejectName,
          location: dispatch.dispatchItems.location,
          reason: dispatch.dispatchItems.reason,
          reasonDescription: dispatch.dispatchItems.reasonDescription
        };
      })
    };
  }

  createBodyEventTurbo(dispatches: any[], type) {
    return {
      event: type,
      origin: 'DISPATCH_MODULE',
      items: dispatches.map(dispatch => {
        return {
          dispatchDate: dispatch.dispatchDate,
          dispatchId: dispatch.dispatchId,
          processedAmount: dispatch.processedAmount,
          saleNoteId: dispatch.saleNoteId,
          skuCode: dispatch.skuCode,
        };
      })
    };
  }
}
